import Vue from 'vue'
import Router from 'vue-router'
import Home from '@/pages/Home'
import Profile from '@/pages/Profile'
import Product from '@/pages/Product'
import Login from '@/pages/Login'
import Upload from '@/pages/Upload'
import Admin from '@/pages/Admin'
import Reset from '@/pages/Reset'
// import Messages from '@/components/Messages'

import HTTP from '@/axios-config'

import store from '../store'

Vue.use(Router)

export default new Router({
  routes: [{
    path: '*',
    redirect: '/'
  }, {
    path: '/',
    name: 'App',
    beforeEnter: (to, from, next) => {
      store.getters.isLoggedInUser ? next('/home') : refreshToken().then((path) => {
        next(path)
      })
    }
  }, {
    path: '/home',
    name: 'Home',
    component: Home,
    beforeEnter: (to, from, next) => {
      store.getters.isLoggedInUser ? next() : refreshToken().then((path) => {
        next(path)
      })
    }
  }, {
    path: '/profile',
    name: 'Profile',
    component: Profile,
    beforeEnter: (to, from, next) => {
      store.getters.isLoggedInUser ? next() : refreshToken().then((path) => {
        next(path)
      })
    }
  },
  {
    path: '/product',
    name: 'Product',
    component: Product,
    beforeEnter: (to, from, next) => {
      store.getters.isLoggedInUser ? isProduct(next) : refreshToken().then((path) => {
        next(path)
      })
    }
  },
  {
    path: '/login',
    name: 'Login',
    component: Login,
    beforeEnter: (to, from, next) => {
      store.dispatch('logoutUser').then(() => next())
    }
  },
  {
    path: '/upload',
    name: 'Upload',
    component: Upload,
    beforeEnter: (to, from, next) => {
      store.getters.isLoggedInUser ? next() : refreshToken().then((path) => {
        next(path)
      })
    }
  },
  {
    path: '/admin',
    name: 'Admin',
    component: Admin,
    beforeEnter: (to, from, next) => {
      store.getters.isLoggedInUser && store.getters.getUser.admin ? next() : next('/')
    }
  }, {
    path: '/reset/:id',
    name: 'Reset',
    component: Reset,
    beforeEnter: (to, from, next) => {
      to.params.id ? next() : Vue.prototype.$bus.$emit('event-toast', 'No tienes autorización para entrar a este sitio')
    }
  }
    /* {
        path: '/messages',
        name: 'Messages',
        component: Messages
      } */
  ],
  scrollBehavior (to, from, savedPosition) {
    return { x: 0, y: 0 }
  }
})

function isProduct (next) {
  store.getters.getProduct ? next() : Vue.prototype.$bus.$emit('event-toast', 'No hay un producto seleccionado')
}

function refreshToken () {
  return new Promise((resolve, reject) => {
    if (JSON.parse(localStorage.getItem('user'))) {
      let requestRefreshToken = {
        email: JSON.parse(localStorage.getItem('user')).email,
        password: JSON.parse(localStorage.getItem('user')).password
      }
      HTTP.post('/user/refreshtoken', requestRefreshToken)
        .then(function (response) {
          localStorage.setItem('user', JSON.stringify(response.data.result))
          localStorage.setItem('token', response.data.token)
          HTTP.defaults.headers.common['Authorization'] = response.data.token
          store.dispatch('loginUser', response.data.result).then(() => {
            if (store.getters.getUser.auth) { resolve('/home') } else { resolve('/login'); Vue.prototype.$bus.$emit('event-toast', 'No tienes autorización') }
          })
        })
        .catch(function (error) {
          console.log(error)
          // reject(error)
          resolve('/login')
          if (error.response) Vue.prototype.$bus.$emit('event-toast', 'Sesión Expirada')
        })
    } else { resolve('/login'); Vue.prototype.$bus.$emit('event-toast', 'No tienes autorización') }
  })
}



// WEBPACK FOOTER //
// ./src/router/index.js